import React from 'react';
import { FormData, TrainingMethod } from '../types/formTypes';

interface TrainingInfoFormProps {
  formData: FormData;
  updateFormData: (updates: Partial<FormData>) => void;
}


const TrainingInfoForm: React.FC<TrainingInfoFormProps> = ({ formData, updateFormData }) => {
  return (
    <div className="form-section">
      <h2>3. 訓練情報</h2>
      
      <div className="form-group">
        <label htmlFor="trainingCourseName">訓練コースの名称 *</label>
        <input
          type="text"
          id="trainingCourseName"
          value={formData.trainingCourseName}
          onChange={(e) => updateFormData({ trainingCourseName: e.target.value })}
          required
        />
      </div>

      <div className="form-group">
        <label>訓練実施期間 *</label>
        <div className="date-range">
          <input
            type="date"
            value={formData.trainingPeriod.startDate}
            onChange={(e) => updateFormData({
              trainingPeriod: { ...formData.trainingPeriod, startDate: e.target.value }
            })}
            required
          />
          <span> 〜 </span>
          <input
            type="date"
            value={formData.trainingPeriod.endDate}
            onChange={(e) => updateFormData({
              trainingPeriod: { ...formData.trainingPeriod, endDate: e.target.value }
            })}
            required
          />
        </div>
      </div>

      {formData.subsidyCategory === '定額制訓練' && (
        <div className="form-group">
          <label>定額制サービス契約期間</label>
          <div className="date-range">
            <input
              type="date"
              value={formData.subscriptionPeriod?.startDate || ''}
              onChange={(e) => updateFormData({
                subscriptionPeriod: { 
                  startDate: e.target.value,
                  endDate: formData.subscriptionPeriod?.endDate || ''
                }
              })}
            />
            <span> 〜 </span>
            <input
              type="date"
              value={formData.subscriptionPeriod?.endDate || ''}
              onChange={(e) => updateFormData({
                subscriptionPeriod: { 
                  startDate: formData.subscriptionPeriod?.startDate || '',
                  endDate: e.target.value
                }
              })}
            />
          </div>
        </div>
      )}

      <div className="form-group">
        <label htmlFor="trainingLocationName">訓練実施場所の名称</label>
        <input
          type="text"
          id="trainingLocationName"
          value={formData.trainingLocation.name}
          onChange={(e) => updateFormData({
            trainingLocation: { ...formData.trainingLocation, name: e.target.value }
          })}
        />
      </div>

      <div className="form-group">
        <label htmlFor="trainingLocationAddress">訓練実施場所の所在地</label>
        <input
          type="text"
          id="trainingLocationAddress"
          value={formData.trainingLocation.address}
          onChange={(e) => updateFormData({
            trainingLocation: { ...formData.trainingLocation, address: e.target.value }
          })}
        />
      </div>

      <div className="form-group">
        <label>訓練の実施方法 *</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="trainingMethod"
              value="通学制"
              checked={formData.trainingMethod === '通学制'}
              onChange={(e) => updateFormData({ trainingMethod: e.target.value as TrainingMethod })}
            />
            通学制
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="trainingMethod"
              value="同時双方向型の通信訓練"
              checked={formData.trainingMethod === '同時双方向型の通信訓練'}
              onChange={(e) => updateFormData({ trainingMethod: e.target.value as TrainingMethod })}
            />
            同時双方向型の通信訓練
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="trainingMethod"
              value="eラーニング"
              checked={formData.trainingMethod === 'eラーニング'}
              onChange={(e) => updateFormData({ trainingMethod: e.target.value as TrainingMethod })}
            />
            eラーニング
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="trainingMethod"
              value="通信制"
              checked={formData.trainingMethod === '通信制'}
              onChange={(e) => updateFormData({ trainingMethod: e.target.value as TrainingMethod })}
            />
            通信制
          </label>
        </div>
      </div>


      <div className="form-group">
        <label>訓練時間数</label>
        <div className="hours-input">
          <div>
            <label htmlFor="totalHours">総訓練時間</label>
            <input
              type="number"
              id="totalHours"
              value={formData.trainingHours.total}
              onChange={(e) => updateFormData({
                trainingHours: { ...formData.trainingHours, total: e.target.value }
              })}
            />
            <span>時間</span>
          </div>
          <div>
            <label htmlFor="academicHours">学科</label>
            <input
              type="number"
              id="academicHours"
              value={formData.trainingHours.academic}
              onChange={(e) => updateFormData({
                trainingHours: { ...formData.trainingHours, academic: e.target.value }
              })}
            />
            <span>時間</span>
          </div>
          <div>
            <label htmlFor="practicalHours">実技</label>
            <input
              type="number"
              id="practicalHours"
              value={formData.trainingHours.practical}
              onChange={(e) => updateFormData({
                trainingHours: { ...formData.trainingHours, practical: e.target.value }
              })}
            />
            <span>時間</span>
          </div>
        </div>
      </div>

      <div className="form-group">
        <label>受講者数</label>
        <div className="participants-input">
          <div>
            <label htmlFor="participantsMale">男性</label>
            <input
              type="number"
              id="participantsMale"
              value={formData.participants.male}
              onChange={(e) => updateFormData({
                participants: { ...formData.participants, male: e.target.value }
              })}
            />
            <span>人</span>
          </div>
          <div>
            <label htmlFor="participantsFemale">女性</label>
            <input
              type="number"
              id="participantsFemale"
              value={formData.participants.female}
              onChange={(e) => updateFormData({
                participants: { ...formData.participants, female: e.target.value }
              })}
            />
            <span>人</span>
          </div>
        </div>
      </div>

      <div className="form-group">
        <div className="radio-group">
          <label>
            <input
              type="checkbox"
              checked={formData.hasQualificationExam}
              onChange={(e) => updateFormData({ hasQualificationExam: e.target.checked })}
            />
            資格試験がある
          </label>
        </div>
      </div>

      {formData.hasQualificationExam && (
        <>
          <div className="form-group">
            <label htmlFor="qualificationExamDetails">資格試験の詳細</label>
            <textarea
              id="qualificationExamDetails"
              value={formData.qualificationExamDetails || ''}
              onChange={(e) => updateFormData({ qualificationExamDetails: e.target.value })}
              rows={3}
            />
          </div>
          <div className="form-group">
            <label htmlFor="qualificationExamDate">資格試験受験日</label>
            <input
              type="date"
              id="qualificationExamDate"
              value={formData.qualificationExamDate || ''}
              onChange={(e) => updateFormData({ qualificationExamDate: e.target.value })}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default TrainingInfoForm;